import $ from 'jquery';
import Skrollr from 'skrollr';

function initParallax() {
  const s = Skrollr.init({
    forceHeight: false,
    beforerender: (props) => {
      if (props.direction === 'up') {
        return false;
      }
    }
  });

  // Don't do skrollr on mobile
  if (s.isMobile()) {
    s.destroy();
  } else {
    $(window).on('load', s.refresh);
  }
}

export default {
  init() {
    initParallax();
  },
  finalize() {

  },
};
